export const DASHBOARD = '/';
export const LOGIN = '/login';
export const SIGN_UP = '/sign-up';
export const MEDITATIONS = '/meditations';
export const DAILY = '/daily';
export const PROFILE = '/p/:username';
export const NOT_FOUND = '/not-found';
